var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Перегляд скріншота")]),_c('v-card-text',[(this.photoUrl !== null)?_c('img',{attrs:{"width":"1250","alt":"","src":_vm.photoUrlFull}}):_vm._e(),(this.photoUrl === null)?_c('div',[_vm._v("Немає зображення")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }